import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { DarkMapIllustration } from './DarkMap';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const DarkMap = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <DarkMapIllustration title={title} />
  </IllustrationWrapper>
);
